import React, { useEffect, useState } from "react";
import axios from "axios";

const Transcript = ({ src, name }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!src) return;
        const fetchTranscript = async () => {
            try {
                setLoading(true);
                const response = await axios.get(src, { skipAuth: true });
                setData(response.data.Transcript);
            } catch (error) {
                console.error("Error fetching transcript:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTranscript();
    }, [src]);

    return (
        <div className="flex flex-col w-full justify-between p-4 gap-4 text-sm pt-0 max-h-[120px] overflow-y-auto">
            {loading ? (
                <p className="">Loading transcript...</p>
            ) : data && data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index}>
                        <span className="font-medium">{item.Speaker === "AI" ? "Assistant" : name}:</span>
                        <p>{item.Text}</p>
                    </div>
                ))
            ) : (
                <p className="">No transcript available.</p>
            )}
        </div>
    );
};

export default Transcript;
